import axios from 'axios'

export default axios.create({
  headers: {
    Accept: '*/*',
    'content-type': 'application/x-www-form-urlencoded',
    'x-requested-with': 'XMLHttpRequest',
  },
})
